import { t } from '@lingui/core/macro'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { formatDateTime } from '@pkg/shared/utils'
import { FaFileAlt } from 'react-icons/fa'
import { PatientFormSchema } from './schema/PatientForm'

export const PatientFormConfig = defineEntityConfig(() => ({
  schema: PatientFormSchema,

  label: t`Formular`,
  labelPlural: t`Formulare`,

  icon: FaFileAlt,

  relationSelectionColumns: [
    {
      title: t`Typ`,
      key: 'type',
      render: (_, record) => record.type,
    },
    {
      title: t`Status`,
      key: 'status',
      render: (_, record) => record.status,
    },
    {
      title: t`Erstellt am`,
      key: 'createdAt',
      render: (_, record) => formatDateTime(record.createdAt),
    },
  ],

  indexColumns: [
    {
      title: t`Typ`,
      key: 'type',
      render: (_, record) => record.type,
    },
    {
      title: t`Status`,
      key: 'status',
      render: (_, record) => record.status,
    },
    {
      title: t`Erstellt am`,
      key: 'createdAt',
      render: (_, record) => formatDateTime(record.createdAt),
    },
  ],

  search: {
    sortableFields: ['type', 'status', 'createdAt'] as const,
    defaultSortBy: 'createdAt',
    defaultSortOrder: 'desc',
  },

  format: {
    primary: val => val?.type,
    secondary: val => val?.status,
  },
}))
